import createReactClass from 'create-react-class'
import React from 'react'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import serviceLocator from 'live/services/service-locator'
import {
    encryptDidMount,
    handleEncryptSubmit
} from 'live/components/forms/ui/UserTable/utils'
import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'

const TABLE = 'table0'
const TYPE = 'sest'

var defaultObject = {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        endpoint: '',
        event_limit: 1000,
        enableForOutput: true,
        curve_sets: {
            table0: {
                curve_map: {}
            },
            table1: {
                curve_map: {}
            }
        },
        wells: [],
        users: {},
        anonymous: true
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
}

var ValidationMixin = require('live/components/forms/mixins/validation-mixin'),
    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')(
        '/rest/extension',
        defaultObject
    ),
    FormBase = require('live/components/extensions/ui/form')

var FormGroup = require('live/components/forms/ui/form-group')

var Form = createReactClass({
    displayName: 'SestForm',
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    endpoint: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Output URL') + ' ' + i18n('must not be empty')
                    },
                    event_limit: {
                        required: true,
                        allowEmpty: false,
                        message: 'Event Limit ' + i18n('must not be empty')
                    }
                }
            }
        }
    },

    componentDidMount () {
        serviceLocator.getService('liverig-wells-shared-components').then(wellsService => {
            var Rigs = wellsService.Rigs

            this.setState({ Rigs })
        })
        serviceLocator.getService('liverig-curves-shared-components').then(curvesService => {
            var Users = curvesService.Users
            var Curves = curvesService.Curves

            this.setState({ Curves, Users })
        })
        encryptDidMount.bind(this)()
    },

    onChangeUsers (value) {
        var object = this.state.object
        let users = {}

        _.map(value, (user, i) => {
            users[(user && user.username) || '_order' + i] = {
                password: (user && user.password) || '',
                order: i
            }
        })

        object.config['users'] = users
        this.applyObj(object)
    },

    onChangeAnonymous (event) {
        var object = this.state.object

        object.config['anonymous'] = !event.target.checked

        this.applyObj(object)
    },

    onChangeCurves (table, values) {
        var object = this.state.object
        var curve_map = {}

        _.map(values, value => {
            if (!_.isEmpty(value)) curve_map[value.curve] = value.output_mnemonic || ''
        })

        object.config = {
            ...object.config,
            curve_sets: {
                ...object.config.curve_sets,
                [table]: {
                    curve_map
                }
            }
        }

        this.applyObj(object)
    },

    onChangeWell: function (wells) {
        var object = this.state.object
        var config = object.config
        let valid = true

        config = {
            ...config,
            wells: _.map(wells, well => {
                if (well.index_type === undefined) valid = false
                if (!well.depth_unit || (well.depth_unit && !well.depth_unit.length)) valid = false

                return {
                    event_type: well.event_type,
                    index_type: well.index_type,
                    depth_unit: well.depth_unit,
                    curve_set: TABLE
                }
            })
        }

        object = {
            ...object,
            config
        }

        this.setState({
            valid
        })

        this.applyObj(object)
    },

    _onAfterFetch: function () {
        let object = this.state.object
        let config = object.config

        // update state
        object = {
            ...object,
            config
        }

        this.applyObj(object)
    },

    _onSuccess: function () {
        window.location.href = '#/integrations/' + TYPE + '/' + this.state.object.id
    },

    _onDelete: function () {
        window.location.href = '#/integrations/'
    },

    render: function () {
        var uiCfg = {
            hideDivider: true
        }

        var object = this.state.object
        var config = object.config

        const { Curves, Rigs, Users } = this.state

        let curveTable0 = (config && config.curve_sets && config.curve_sets[TABLE]) || {}
        handleEncryptSubmit.bind(this)()
        return (
            <EncryptForm self={this} uiCfg={uiCfg} test={false}>
                <div className={'export-form ' + TYPE}>
                    <div className="form-area">
                        <FormGroup
                            type="text"
                            label={i18n('Output URL')}
                            name="config.endpoint"
                            value={config.endpoint}
                            placeholder={'http://0.0.0.0:52535/liverig/' + TYPE}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.endpoint')}
                            hasFeedback
                            help={this.errorsFor('config.endpoint')}
                        />

                        <FormGroup
                            type="number"
                            label="Event Limit"
                            className="event-limit"
                            name="config.event_limit"
                            value={parseInt(config.event_limit)}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.event_limit')}
                            hasFeedback
                            help={this.errorsFor('config.event_limit')}
                        />

                        {Users ? (
                            <Users
                                onChange={this.onChangeUsers}
                                onChangeAnonymous={this.onChangeAnonymous}
                                object={object}
                                initPassword={this.state?.original?.config?.users}
                                setEditing={this.state.setHasUnSavedPassword}
                            />
                        ) : null}
                    </div>
                    <hr />

                    {Curves ? (
                        <Curves
                            onChange={values => this.onChangeCurves(TABLE, values)}
                            config={config}
                            curve_map={curveTable0 && curveTable0.curve_map}
                            enableOutput={true}
                        />
                    ) : null}

                    <div className="rigs-container">
                        {Rigs ? (
                            <Rigs onChange={this.onChangeWell} config={config} depth={true} hasFeedback={true} />
                        ) : null}
                    </div>
                </div>
            </EncryptForm>
        )
    }
})

module.exports = Form
